import allModels from '../../app/modules/models'
import allMods from '../../app/modules/index'
import bootstrapClient from '../../app/utils/bootstrap-client'

bootstrapClient(allMods, allModels)
